import { createPortal } from 'react-dom';

export default function ReactPortal({ children }) {
  return createPortal(children, document.body);
}
